<div class="d-flex justify-content-end w-100 s-mb-5">
  <z-button [label]="'COMMON.ADD' | translate" (click)="openNewItemDialog()" [icon]="'add'">
  </z-button>
</div>
@if (formControlRef().value && formControlRef().value.length) {
  <div class="table-responsive">
    <app-simple-table
      [columns]="columns()"
      [actions]="actions()"
      [items]="formControlRef().value || []"
      (action)="tableAction($event)"
      [allowSelection]="allowSelection()"
    >
    </app-simple-table>
  </div>
} @else {
  <app-empty-data> </app-empty-data>
}
